const STORAGE_KEY = 'novaTuitionJoinContextV1';

/**
 * Persist lesson join metadata so a refresh on ?roomUrl=... can restore childId / tokens
 * for Daily userData.mongoChildId and the confirm-join flow.
 */
export function persistJoinContext(roomUrl, context) {
  if (!roomUrl || context?.childId == null) return;
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        roomUrl,
        childId: String(context.childId),
        lessonScheduleId:
          context.lessonScheduleId != null ? String(context.lessonScheduleId) : '',
        joinVersionToken: context.joinVersionToken ?? null,
        joinVersionExpiresAt: context.joinVersionExpiresAt ?? null,
        idempotencyKey: String(
          context.idempotencyKey || `${context.childId}:${Date.now()}`,
        ),
      }),
    );
  } catch {
    // ignore quota / private mode
  }
}

/**
 * Returns join context if session storage matches this room URL (exact string match).
 */
export function readJoinContextForRoom(requestedRoomUrl) {
  if (!requestedRoomUrl) return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data || data.roomUrl !== requestedRoomUrl || data.childId == null) {
      return null;
    }
    return {
      childId: data.childId,
      lessonScheduleId: data.lessonScheduleId || null,
      joinVersionToken: data.joinVersionToken,
      joinVersionExpiresAt: data.joinVersionExpiresAt ?? null,
      idempotencyKey:
        data.idempotencyKey || `${data.childId}:${Date.now()}`,
    };
  } catch {
    return null;
  }
}

export function clearPersistedJoinContext() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
